import { createContext, useContext, useState, useEffect, useCallback, useMemo } from 'react';

const CART_KEY = 'gct_cart';
const CartContext = createContext(null);

function readCart() {
  try { return JSON.parse(window.localStorage.getItem(CART_KEY) || '[]'); } catch { return []; }
}

export function CartProvider({ children }) {
  const [items, setItems] = useState(readCart);

  useEffect(() => { window.localStorage.setItem(CART_KEY, JSON.stringify(items)); }, [items]);

  const addItem = useCallback((variety, quantity) => {
    setItems((prev) => {
      const existing = prev.find((i) => i.variety_id === variety.id);
      if (existing) {
        return prev.map((i) => i.variety_id === variety.id ? { ...i, quantity_m2: i.quantity_m2 + quantity } : i);
      }
      return [...prev, { variety_id: variety.id, name: variety.name, slug: variety.slug, price_per_m2: variety.price_per_m2, min_order_m2: variety.min_order_m2, photo: variety.photos?.[0] || null, quantity_m2: quantity }];
    });
  }, []);

  const updateQuantity = useCallback((varietyId, quantity) => {
    setItems((prev) => prev.map((i) => i.variety_id === varietyId ? { ...i, quantity_m2: quantity } : i));
  }, []);

  const removeItem = useCallback((varietyId) => {
    setItems((prev) => prev.filter((i) => i.variety_id !== varietyId));
  }, []);

  const clear = useCallback(() => setItems([]), []);

  const value = useMemo(() => {
    const totalM2 = items.reduce((s, i) => s + (Number(i.quantity_m2) || 0), 0);
    const subtotal = items.reduce((s, i) => s + (Number(i.quantity_m2) || 0) * i.price_per_m2, 0);
    return { items, addItem, updateQuantity, removeItem, clear, totalM2, subtotal, count: items.length };
  }, [items, addItem, updateQuantity, removeItem, clear]);

  return <CartContext.Provider value={value}>{children}</CartContext.Provider>;
}

export function useCart() {
  const ctx = useContext(CartContext);
  if (!ctx) throw new Error('useCart must be used within CartProvider');
  return ctx;
}

export const formatAUD = (n) => new Intl.NumberFormat('en-AU', { style: 'currency', currency: 'AUD' }).format(n || 0);
